import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '@services/auth.service';

export interface Location {
  id: string;
  name: string;
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule
  ],
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent {
  @Input() location: Location | null = null;
  @Input() locations: Location[] = [];
  @Output() locationChange = new EventEmitter<Location>();

  isUserMenuOpen = false;

  constructor(private authService: AuthService) {}

  get userName(): string {
    return this.authService.getUserName();
  }

  get userEmail(): string {
    return this.authService.getUserEmail();
  }

  onLocationClick(location: Location): void {
    this.locationChange.emit(location);
  }

  onProfile(): void {
    // TODO: Navigate to profile page or open profile modal
    console.log('Profile clicked');
  }

  onSettings(): void {
    // TODO: Navigate to settings page or open settings modal
    console.log('Settings clicked');
  }

  onLogout(): void {
    this.authService.logout();
  }
}
